var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHatenaButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.643,
    height: 74.643,
    viewBox: "0 0 74.643 74.643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15944",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15944",
    transform: "translate(-165 -551.064)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_4833",
    "data-name": "\\u6955\\u5186\\u5F62 4833",
    cx: 37.321,
    cy: 37.322,
    rx: 37.321,
    ry: 37.322,
    transform: "translate(165 551.064)",
    fill: "#5f2fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21951",
    "data-name": "\\u30D1\\u30B9 21951",
    d: "M9.866,23.394h8.059V21.767a6.636,6.636,0,0,1,.456-2.577,5.8,5.8,0,0,1,1.581-2.075,20.2,20.2,0,0,1,3.147-2.159A16.611,16.611,0,0,0,26.7,12.188a10.236,10.236,0,0,0,2.174-3.36,11.21,11.21,0,0,0,.73-4.136V4.631a10.6,10.6,0,0,0-1.8-6.112,11.985,11.985,0,0,0-5.048-4.136,18.05,18.05,0,0,0-7.595-1.49A17.775,17.775,0,0,0,7.236-5.5,11.845,11.845,0,0,0,2.218-1.017,13.006,13.006,0,0,0,.378,5.559v.061L8.6,5.589l.061-.015A6.233,6.233,0,0,1,9.5,2.6,5.19,5.19,0,0,1,11.577.64a6.454,6.454,0,0,1,3.049-.692,6.735,6.735,0,0,1,3.033.646A5.008,5.008,0,0,1,19.681,2.35,4.578,4.578,0,0,1,20.4,4.9v.061a6.306,6.306,0,0,1-.456,2.486A5.748,5.748,0,0,1,18.373,9.5a21.782,21.782,0,0,1-3.079,2.144,14.675,14.675,0,0,0-3.368,2.63,7.756,7.756,0,0,0-1.787,3.178,12.086,12.086,0,0,0-.319,4.181Zm4.349,14.642a5.735,5.735,0,0,0,4.044-1.361,4.809,4.809,0,0,0,1.475-3.718,4.847,4.847,0,0,0-1.475-3.748,5.735,5.735,0,0,0-4.044-1.361A5.769,5.769,0,0,0,10.17,29.21a4.822,4.822,0,0,0-1.49,3.748,4.784,4.784,0,0,0,1.49,3.718A5.769,5.769,0,0,0,14.215,38.036Z",
    transform: "translate(187.621 573.171)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatenaButton);
export default __webpack_public_path__ + "static/media/hatenaButton.6f53fde9590d8d47a15956d0ef26807f.svg";
export { ForwardRef as ReactComponent };